import React from 'react';
import { Table } from 'react-bootstrap'
import { 
  formatPercent, 
  numFormat, 
  priceColor, 
  earningDateColor,
  format,
  formatDateYYYYMMDD
} from '../Dashboard/Helpers';

const StockTech = ({ tickerInfo }) => {

  function mapTickers() {
    return tickerInfo.map((item) => {
      return (
        <tr key={ item.symbol }>
          <td>{ item.symbol }</td>
          <td>{ item.name }</td>
          <td>{ format(item.price) }</td>
          <td className={priceColor(item.percentChange)}>{ formatPercent(item.percentChange) }</td>
          <td>{ item.previousClose }</td>
          <td>{ item.yearRange }</td>
          <td className={earningDateColor(item.earningsDate)}>{ formatDateYYYYMMDD(item.earningsDate) }</td>
          <td>{ item.open }</td>
          <td>{ numFormat(item.marketCap) }</td>
          <td>{ item.PERatio }</td>
          <td>{ item.EPS }</td>
          <td>{ item.dividend } ({ formatPercent(item.dividendPercent) })</td>
          <td>{ item.fiftyDayMovingAvg }</td>
          <td>{ item.beta }</td>
          <td>{ item.quarterly }</td>
          
          <td>{ item.BofAML12 }</td>
          <td>{ item.BofAML5 }</td>
          <td>{ item.MLRating }</td>
          <td>{ item.MSRating }</td>
          <td>{ item.SNPRating }</td>
        </tr>
      );
    });
  }

  return (
    <Table responsive className="stock-technicals-table">
      <thead>
        <tr>
          <th>Ticker</th>
          <th>Company Name</th>
          <th>Price</th>
          <th>% Change</th>
          <th>Prev. Close</th>
          <th>Year Range</th>
          <th>Earnings Date</th>
          <th>Open</th>
          <th>Market Cap</th>
          <th>P/E Ratio</th>
          <th>EPS</th>
          <th>Dividend</th>
          <th>50 Day Moving Avg</th>
          <th>Beta</th>
          <th>Quarterly</th>
          
          <th>BofAML12</th>
          <th>BofAML5</th>
          <th>ML Rating</th>
          <th>MS Rating</th>
          <th>SNP Rating</th>
        </tr>
      </thead>
      <tbody>
        { mapTickers() }
      </tbody>
    </Table>
  );
}

export default StockTech;
